export default "__VITE_ASSET__D$S6BjIx__"